<template>
  <el-dialog
    :title="$t('common.map')"
    :visible.sync="viewMapInfo.showMap"
    width="80%"
    :before-close="closeMap"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <div class="map-container">
      <div id="qqmapcontainer" style="width: 100%; height: 500px; background-color: antiquewhite;"></div>
    </div>
  </el-dialog>
</template>

<script>
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

export default {
  name: 'ViewMap',
  data() {
    return {
      viewMapInfo: {
        lat: '',
        lng: '',
        showMap: false,
        map: null,
        marker: null
      },
      amapKey: ''
    }
  },
  async mounted() {
    await this.loadAmapKey()
    await this.loadAmapScript()
  },
  methods: {
    async loadAmapKey() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0 && data[0].qqMapKey) {
          this.amapKey = data[0].qqMapKey
        } else {
          this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
        }
      } catch (error) {
        console.error('获取地图Key失败:', error)
        this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
      }
    },

    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}`
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    open(param) {
      this.viewMapInfo.showMap = true

      if (param.lng && param.lat) {
        const lngLat = this.wgs84togcj02(param.lng, param.lat)
        this.viewMapInfo.lat = lngLat.lat
        this.viewMapInfo.lng = lngLat.lon
      } else {
        this.viewMapInfo.lat = 36.72
        this.viewMapInfo.lng = 100.985
      }

      this.$nextTick(() => this.initMap())
    },

    initMap() {
      const center = [this.viewMapInfo.lng, this.viewMapInfo.lat]
      const container = document.getElementById('qqmapcontainer')

      this.viewMapInfo.map = new window.AMap.Map(container, {
        center: center,
        zoom: 17,
        viewMode: '2D'
      })

      this.viewMapInfo.marker = new window.AMap.Marker({
        position: center,
        map: this.viewMapInfo.map
      })
    },

    closeMap() {
      this.viewMapInfo.showMap = false
      if (this.viewMapInfo.marker) {
        this.viewMapInfo.marker.setMap(null)
        this.viewMapInfo.marker = null
      }
      if (this.viewMapInfo.map) {
        this.viewMapInfo.map.destroy()
        this.viewMapInfo.map = null
      }
    },

    wgs84togcj02(lng, lat) {
      // Placeholder for coordinate conversion
      return { lon: lng, lat }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 500px;
}
</style>